/**
 * Returns true if running in enterprise env
 */
const isEnterpriseEnv = (): boolean => {
  return process.env.REACT_APP_ENTERPRISE === 'true';
};

export default isEnterpriseEnv;
